import { Component } from '@angular/core';

@Component({
  selector: 'app-business',
  standalone: true,
  imports: [],
  templateUrl: './business.component.html',
  styleUrl: './business.component.scss'
})
export class BusinessComponent {

}
